// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zg-quote[data-v-22f9864f]{position:relative;max-width:-webkit-max-content;max-width:-moz-max-content;max-width:max-content;background-color:#f6f3e9;border-radius:2rem;padding:1rem;margin-bottom:1rem}.zg-quote p[data-v-22f9864f]{margin-bottom:0}.zg-quote__arrow[data-v-22f9864f]{position:absolute;left:3rem;top:calc(100% - 0.5rem);-webkit-transform:scaleX(-1);transform:scaleX(-1)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
